import { AssetItem } from 'Api/Services';
import { IPlayerContext } from 'App/Areas/Shares/IPlayerContext';
import { BaseDialogBehavior } from 'App/Services/DialogService/BaseDialogBehavior';
import { Component } from 'Framework/Components/UIElement';
import VueMarkdown from 'vue-markdown';

@Component({
    name: 'FolderWithCommentDialog',
    components: { VueMarkdown }
})
export default class FolderWithCommentDialog extends BaseDialogBehavior<{
    playerContext: IPlayerContext,
    assetItem: AssetItem,
    comment: string
}> {
    public getChildren(folderId: number): Array<AssetItem> {
        return this.dataContext
            .playerContext
            .findAssetFileFromAssetFolderId(folderId, true)
            .sort((a, b) => a.name.localeCompare(b.name));
    }

    public get subFolders(): Array<AssetItem> {
        if (this.dataContext.assetItem) {
            return this.dataContext
                .playerContext
                .findAssetFileFromAssetFolderId(this.dataContext.assetItem.assetItemId)
                .sort((a, b) => a.name.localeCompare(b.name));
        } else {
            return [];
        }
    }
}
